/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */
import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import PropTypes from 'prop-types';

/**
 * A React component for cancel button icon.
 *
 * @author Mohamed yasar arabath M
 */

const CancelLg = ({ className, fillColor }) => (
  <SvgIcon className={className} viewBox="0 0 18 18">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-1192.000000, -23.000000)">
        <g>
          <g transform="translate(1192.000000, 23.000000)">
            <rect x="0" y="0" width="18" height="18" />
            <path d="M9.927975,9 L17.806725,1.12125 C18.063225,0.86475 18.063225,0.4485 17.806725,0.192 C17.550975,-0.06375 17.135475,-0.06375 16.878975,0.192 L8.999475,8.0715 L1.119975,0.192 C0.864225,-0.06375 0.448725,-0.06375 0.192225,0.192 C-0.064275,0.4485 -0.064275,0.86475 0.192225,1.12125 L8.070975,9 L0.192225,16.87875 C-0.064275,17.13525 -0.064275,17.5515 0.192225,17.808 C0.320475,17.93625 0.488475,18 0.656475,18 C0.824475,18 0.991725,17.93625 1.119975,17.808 L8.999475,9.9285 L16.878975,17.808 C17.007225,17.93625 17.175225,18 17.343225,18 C17.511225,18 17.678475,17.93625 17.806725,17.808 C18.063225,17.5515 18.063225,17.13525 17.806725,16.87875 L9.927975,9 Z" fill={fillColor} />
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
);

CancelLg.propTypes = {
  className: PropTypes.string,
  fillColor: PropTypes.string
};

CancelLg.defaultProps = {
  fillColor: 'currentColor'
};

export default CancelLg;



// WEBPACK FOOTER //
// ./src/js/icons/CancelLg.jsx